import React, { Component } from "react";
import { Container } from "react-bootstrap";

class Footer extends Component{
    render(){
        return(
            <Container className="text-center">
                <p>warehouse robot&copy;2024</p>
            </Container>
        );
    }
}

export default Footer;